<template>
  <a-modal
      width="90vw" centered :footer="false" :closable="false"
      :visible="visible"
      :destroyOnClose="true">
    <div style="margin: -24px">
      <div class="zjmp">
        <a-row type="flex" style="flex-wrap: nowrap">
          <a-col flex="0 0 auto" style="width: 500px">
            <div class="left">
              <div class="zjmp_t1">
                <expert-upload-view ref="avatarRef" avatar-flag config-key="expert.apply.peoplePicture" :refer-id="id"/>
                <div class="info">
                  <div class="r1">
                    <span class="text1">{{ expertInfoView.expertInfo.expertName }}</span>
                    <a-tag class="mt-1" style="border-radius: 4px; padding: 2px 8px;margin-left: 9px;font-size: 14px;"
                           v-for="item in expertInfoView.expertInfo.extras.tagInfos"
                           :key="item.id"
                           :title="item.tagDetail"
                           :color="item.tagColor">
                      {{ item.tagName }}
                    </a-tag>
                    <span class="tag v2" v-if="expertInfoView.expertInfo.emergencyFlag === '1'"><a-icon
                        type="thunderbolt"
                        theme="filled"/>{{ expertInfoView.expertInfo.extras.emergencyFlagText }}</span>
                    <span v-if="IsExpertInfoAdmin()" class="tag v3" @click="openTagEdit"><a-icon type="edit"
                                                                                                 theme="filled"/> 编辑标签</span>
                  </div>
                  <div class="text2">{{ expertInfoView.expertInfo.idCard }}</div>
                  <div class="text2">{{ expertInfoView.expertInfo.mobilePhone }}</div>
                  <div class="text2">{{ expertInfoView.expertInfo.extras.areaAddressText }}</div>
                  <div class="text2">
                    状态：
                    <a-tag color="#5DCC6F">{{ expertInfoView.expertInfo.extras.stateText }}</a-tag>
                    <span @click="edit.stateVisible=true" class="tag v3"><a-icon type="edit"
                                                                                 theme="filled"/> 编辑状态</span>
                  </div>
                  <div class="text2" style="color: red"
                       v-if="ExpertState.STATE.LEAVE_DOING === expertInfoView.expertInfo.state">
                    {{ expertInfoView.expertInfo.notExtractStartTime | dayjs('YYYY-MM-DD') }}至
                    <template v-if="expertInfoView.expertInfo.notExtractEndTime">
                      {{ expertInfoView.expertInfo.notExtractEndTime | dayjs('YYYY-MM-DD') }}
                    </template>
                    <template v-else>
                      长期
                    </template>
                  </div>
                </div>
              </div>
              <div class="zjmp_t2">
                <div>{{ expertInfoView.expertInfo.remark }}<span class="tag v3" @click="edit.remarkVisible=true"><a-icon
                    type="edit" theme="filled"/> {{
                    showRemarkIcon
                  }}</span>
                </div>
              </div>
              <div class="zjmp_t3">
                <!-- 正常-->
                <div>入库：{{ expertInfoView.expertInfo.addDate | dayjs('YYYY-MM-DD') }}</div>
                <div>已入库<b>{{ expertInfoView.expertInfo.addDate | fromNow }}</b>天</div>
              </div>
              <div class="zjmp_t3" v-if="ExpertState.STATE.OUT_SUCCESS === expertInfoView.expertInfo.state">
                <!--已出库-->
                <div>出库：{{ expertInfoView.expertInfo.stockOutDate  | dayjs('YYYY-MM-DD') }}</div>
                <div>原因:{{ expertInfoView.expertInfo.stockOutReason }}</div>
              </div>
              <extract-num-view
                  :expert-flag-num-info="{attendRate:expertInfoView.attendRate,...expertInfoView.singleExpertFlagNumVo}"/>
              <div class="zjmp_t5">
                <a-row :gutter="[12,8]">
                  <a-col :span="8">
                    <a-button @click="record.historyVisible=true" type="primary" block>抽取记录</a-button>
                  </a-col>
                  <a-col :span="8">
                    <a-button type="primary" @click="record.leaveVisible=true" block>请假记录</a-button>
                  </a-col>
                  <a-col :span="8">
                    <a-button type="primary" @click="record.holidayVisible=true" block>休假记录</a-button>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-col>
          <a-col style="width: 100%;overflow: auto">
            <div class="right">
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="基本信息">
                  <basic-info-view :expert-info="expertInfoView.expertInfo"/>
                </a-tab-pane>
                <a-tab-pane key="2" tab="回避单位">
                  <p>有<b style="color: red;font-size: 18px">{{ avoidUnitList.length }}</b>家回避单位</p>
                  <div class="zjmp_t6">
                    <a-tag v-for="item in avoidUnitList" :key="item">{{ item }}</a-tag>
                    <a-empty v-if="avoidUnitList.length === 0"/>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="3" tab="证明材料">
                  <material-view :id="expertInfoView.expertInfo.id"/>
                </a-tab-pane>
              </a-tabs>
            </div>
          </a-col>
        </a-row>
        <div class="btn_box">
          <template v-if="IsExpertInfoAdmin()">
            <a-button>资料变更记录</a-button>
            <a-button @click="onEdit" type="primary">
              修改专家资料
            </a-button>
          </template>
          <a-button type="danger" @click="$emit('cancel')">
            <a-icon type="close"/>
          </a-button>
        </div>
      </div>
      <expert-event-history-record @cancel="record.historyVisible=false"
                                   @success="record.historyVisible=false" :historyVisible="record.historyVisible"
                                   :expertId="id"/>
      <expert-ask-for-leave-record @cancel="record.leaveVisible=false"
                                   @success="record.leaveVisible=false" :leaveVisible="record.leaveVisible"
                                   :expertId="id"/>
      <expert-holiday-record @cancel="record.holidayVisible=false"
                             @success="record.holidayVisible=false" :holidayVisible="record.holidayVisible"
                             :expertId="id"/>
      <edit-expert-remark-modal @cancel="edit.remarkVisible=false"
                                @success="afterSuccess('remarkVisible')" :remarkVisible="edit.remarkVisible"
                                :expert-info="{...expertInfoView.expertInfo}"/>
      <edit-expert-state-modal @cancel="edit.stateVisible=false" @success="afterSuccess('stateVisible')"
                               :stateVisible="edit.stateVisible" :expert-info="{...expertInfoView.expertInfo}"/>
      <edit-expert-tag-modal @cancel="edit.tagVisible=false" @success="afterSuccess('tagVisible')"
                             :tagVisible="edit.tagVisible" ref="editExpertTagRef"/>
    </div>
  </a-modal>
</template>

<script>
import { GetExpertInfoView } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import ExpertEventHistoryRecord from '@/epp/expertmain/expertInfo/common/record/ExpertEventHistoryRecord.vue'
import MaterialView from '@/epp/expertmain/expertInfo/common/viewitem/MaterialView.vue'
import BasicInfoView from '@/epp/expertmain/expertInfo/common/viewitem/BasicInfoView.vue'
import ExtractNumView from '@/epp/expertmain/expertInfo/common/viewitem/ExtractNumView.vue'
import ExpertUploadView from '@/components/selector/ExpertUploadView.vue'
import { ExpertState } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import ExpertAskForLeaveRecord from '@/epp/expertmain/expertInfo/common/record/ExpertAskForLeaveRecord.vue'
import ExpertHolidayRecord from '@/epp/expertmain/expertInfo/common/record/ExpertHolidayRecord.vue'
import EditExpertRemarkModal from '@/epp/expertmain/expertInfo/common/edititem/EditExpertRemarkModal.vue'
import EditExpertStateModal from '@/epp/expertmain/expertInfo/common/edititem/EditExpertStateModal.vue'
import dayjs from 'dayjs'
import EditExpertTagModal from '@/epp/expertmain/expertInfo/common/edititem/EditExpertTagModal.vue'
import ExpertEdit from '@/epp/expertmain/expertInfo/ExpertEdit.vue'
import { IsExpertInfoAdmin } from '@/epp/expertmain/userperm/UserPermUtil'

export default {
  name: 'expertView',
  components: {
    ExpertEdit,
    EditExpertTagModal,
    EditExpertStateModal,
    EditExpertRemarkModal,
    ExpertHolidayRecord,
    ExpertAskForLeaveRecord,
    ExpertUploadView,
    ExtractNumView,
    BasicInfoView,
    MaterialView,
    ExpertEventHistoryRecord
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      expertInfoView: {
        expertInfo: { extras: {} },
        singleExpertFlagNumVo: {},
        storageDays: 0,
        attendRate: 0
      },
      id: undefined,
      ExpertState,
      record: {
        historyVisible: false,
        leaveVisible: false,
        holidayVisible: false,
      },
      edit: {
        remarkVisible: false,
        stateVisible: false,
        tagVisible: false
      }
    }
  },
  created () {
  },
  computed: {
    //备注按钮是否显示文字
    showRemarkIcon () {
      return this.expertInfoView.expertInfo.remark ? '' : '编辑备注'
    },
    //回避单位
    avoidUnitList () {
      let unitList = this.expertInfoView.expertInfo.unitName ? [this.expertInfoView.expertInfo.unitName] : []
      unitList = unitList.concat(this.expertInfoView.expertInfo.avoidUnit ? this.expertInfoView.expertInfo.avoidUnit.split(',') : [])
      //单位去重
      unitList = [...new Set(unitList)]
      return unitList
    },
  },
  methods: {
    IsExpertInfoAdmin,
    async loadData (id) {
      this.id = id
      const res = await GetExpertInfoView(this.id)
      this.expertInfoView = { ...res.result }
    },
    afterSuccess (visible) {
      this.edit[visible] = false
      this.loadData(this.id)
      this.$emit('success')
    },
    //编辑专家信息
    onEdit () {
      this.$emit('cancel')
      this.$emit('openEdit', this.id)
    },
    //标签编辑
    openTagEdit () {
      this.edit.tagVisible = true
      let { id, emergencyFlag } = this.expertInfoView.expertInfo
      let { tagIds } = this.expertInfoView.expertInfo.extras
      this.$refs.editExpertTagRef.onStartLoadData({ tagId: tagIds, expertIdList: [id], emergencyFlag: emergencyFlag })
    },
  },

}
</script>

<style scoped>
</style>
